import { render, staticRenderFns } from "./addtion.vue?vue&type=template&id=492d9d82&scoped=true&"
import script from "./addtion.vue?vue&type=script&lang=js&"
export * from "./addtion.vue?vue&type=script&lang=js&"
import style0 from "./addtion.vue?vue&type=style&index=0&id=492d9d82&scoped=true&lang=scss&"
import style1 from "./addtion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d9d82",
  null
  
)

export default component.exports